import api from 'api'

interface FetchWithTokenProps {
  method: string // get, post, put, delete
  resource?: string // see baseApi for all the resources
  path?: string // the API endpoint we want to hit
  filters?: string // optional filters
  options?: any // other params
  useV5?: boolean // whether or not to pass `/v5/` in the call
  useVersion?: string // the version of the resource to use
  useBasePath?: boolean // whether or not to use the basePath
  useGoToBasePath?: boolean // whether or not to use the new api.goto.com base bath or the legacy api.jive.com
  externalUrl?: string // if we want to provide the full URL ourselves
  baseUrl?: string // if you need to use a baseUrl different from jive or external admin
  useExternalAdmin?: boolean // whether or not we want to fetch a resource from the external admin portal
  isUsingLocationsBff?: boolean // whether or not to use the Location BFF
  handleUnauthorized?: boolean
  useReqPath?: boolean // whether or not to add the path value to the URL
}

const fetchWithToken = ({
  method = 'GET',
  resource,
  path,
  filters,
  options = {},
  useV5 = true,
  useVersion = api.version,
  useBasePath = true,
  useGoToBasePath = false,
  baseUrl,
  externalUrl,
  handleUnauthorized,
  useReqPath = true,
}: FetchWithTokenProps): any => {
  const {
    headers = {
      Accept: 'application/json, text/plain, */*',
      'Content-Type': 'application/json',
    },
    handleAuthorize,
    ...otherOptions
  } = options

  const newBaseUrl = baseUrl ? baseUrl : useGoToBasePath ? api.gotoBaseUrl : api.baseUrl

  // Building the request URL
  const myBaseUrl = useBasePath ? `${newBaseUrl}` : ''
  const reqV5 = useV5 ? `/${api.v5}` : ''
  const reqResource = resource ? `/${resource}` : ''
  const reqVersion = useVersion ? `/${useVersion}` : ''
  const reqPath = useReqPath ? `/${path}` : ''
  const reqFilters = filters ? `?${filters}` : ''

  // Putting it all together
  const reqUrl = `${myBaseUrl}${reqV5}${reqResource}${reqVersion}${reqPath}${reqFilters}`

  return global.fetchAdmin(
    externalUrl || reqUrl,
    {
      method,
      headers,
      ...otherOptions,
      handleAuthorize,
    },
    handleUnauthorized,
  )
}

export default fetchWithToken
